import { OnInit, Renderer2, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroupDirective, Validators, FormGroup, FormControl } from '@angular/forms';
import { ValidatorFactories, } from '../../../core/validators';
import { FormsService } from '../../../core/services/forms.service';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var passwordValidator = ValidatorFactories.password(6, false, true, true, true);
var CreateAccountPageComponent = /** @class */ (function () {
    function CreateAccountPageComponent(forms, store, renderer, modalService) {
        var _this = this;
        this.forms = forms;
        this.store = store;
        this.renderer = renderer;
        this.modalService = modalService;
        this.submitting = false;
        this.submitEvent = new EventEmitter();
        this.store.pipe(select(fromBase.getTenantCode))
            .subscribe(function (tentantCode) {
            _this.clientNumberImageSrc = 'https://res.cloudinary.com/orderfield/image/upload/v1554992673/' + tentantCode + '/miscellaneous/whereismyclientnumber.jpg';
        });
        this.fullWidthView$ = store
            .pipe(select(fromBase.isFullWidthViewEnabled));
        this.form = new FormGroup({
            customerCode: new FormControl('', Validators.required),
            zipCode: new FormControl('', Validators.required),
            fullname: new FormControl('', Validators.required),
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required, passwordValidator])
        });
        // this.form = this.forms.group({
        //   customerCode: [
        //     '', [Validators.required], 'create-acc.fields.customer-code'
        //   ],
        //   zipCode: [
        //     '', [Validators.required], 'create-acc.fields.postal'
        //   ],
        //   fullname: [
        //     '', [Validators.required], 'create-acc.fields.fullname'
        //   ],
        //   email: [
        //     '', [Validators.required, Validators.email], 'create-acc.fields.email'
        //   ],
        //   password: [
        //     '', [Validators.required, passwordValidator], 'create-acc.fields.password'
        //   ]
        // })
    }
    Object.defineProperty(CreateAccountPageComponent.prototype, "submitSetter", {
        set: function (value) {
            this.submitting = value;
            if (this.form)
                if (value)
                    this.form.disable();
                else
                    this.form.enable();
        },
        enumerable: true,
        configurable: true
    });
    CreateAccountPageComponent.prototype.ngOnInit = function () {
        // add login class to body for background image
        this.renderer.addClass(document.body, 'login');
        // If userAccountNeedsValidation is false, zipCode is also required
        if (!this.userAccountNeedsValidation) {
            this.form.addControl('zipCode', new FormControl('', Validators.required));
        }
    };
    CreateAccountPageComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes.userAccountNeedsValidation && changes.userAccountNeedsValidation.currentValue) {
            // userAccountNeedsValidation is true, remove the zipCode from the form since this is not needed then.
            this.form.removeControl('zipCode');
        }
    };
    CreateAccountPageComponent.prototype.ngOnDestroy = function () {
        // remove login class
        this.renderer.removeClass(document.body, 'login');
    };
    CreateAccountPageComponent.prototype.submitForm = function () {
        if (this.form.valid) {
            this.submitEvent.emit(this.form.value);
        }
    };
    CreateAccountPageComponent.prototype.openModal = function (content) {
        this.modalService.open(content, { backdropClass: 'dark-backdrop', windowClass: 'clientnumbermodal' });
    };
    return CreateAccountPageComponent;
}());
export { CreateAccountPageComponent };
